var u, t;
function s() {
  if (t) return u;
  t = 1;
  function d(a, n, e, o) {
    for (var r = a & 65535 | 0, f = a >>> 16 & 65535 | 0, i = 0; e !== 0; ) {
      i = e > 2e3 ? 2e3 : e, e -= i;
      do
        r = r + n[o++] | 0, f = f + r | 0;
      while (--i);
      r %= 65521, f %= 65521;
    }
    return r | f << 16 | 0;
  }
  return u = d, u;
}
export {
  s as __require
};
//# sourceMappingURL=adler32.es.js.map
